import { Component } from '@angular/core';

@Component({
    selector: 'app-page-gestionvisitas',
    templateUrl: './page-gestionvisitas.component.html',
    styleUrls: ['./page-gestionvisitas.component.css'],
    standalone: false
})
export class PageGestionvisitasComponent {

}
